export class AppFieldGroup extends HTMLElement {
  static get observedAttributes() {
    return ["columns"];
  }

  connectedCallback() {
    this.render();
  }

  attributeChangedCallback() {
    this.render();
  }

  private render() {
    const cols = this.getAttribute("columns") || "2";
    this.className = `field-grid-${cols}`;
  }
}

if (!customElements.get("app-field-group")) {
  if (!customElements.get("app-field-group")) {
    customElements.define("app-field-group", AppFieldGroup);
  }
}

export class AppTechnicalForm extends HTMLElement {
  connectedCallback() {
    this.style.display = "flex";
    this.style.flexDirection = "column";
    this.style.gap = "20px";
  }
}

if (!customElements.get("app-technical-form")) {
  if (!customElements.get("app-technical-form")) {
    customElements.define("app-technical-form", AppTechnicalForm);
  }
}
